// extracted by mini-css-extract-plugin
export default {"loader_container":"loader_loader_container__HtvZE","loader":"loader_loader__Afxp8"};